import React, { useState, useRef, useEffect } from "react";
import NavbarBrandBox from "./NavbarBrandBox";
import MyCartDropdown from "./MyCartDropdown";
import NotificationDropdown from "./NotificationDropdown";
import { Link } from "react-router-dom";
import ProfileDropdownn from "./ProfileDropdownn";
import { License } from "types";
import logo from "../assets/images/RealEsy_V01.svg";
import { getAuthCookie } from "../utils/authCookies";
const SignageHeader = () => {
  const [isActive, setIsActive] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const divRef = useRef<HTMLDivElement | null>(null);
  const userName = getAuthCookie("userName");
  const userType = getAuthCookie("userType");
  const token = getAuthCookie("sessionToken");
  const [license, setLicense] = useState<License | null>(null);
  const [error, setError] = useState<string>("");
  const organizationId = getAuthCookie("organizationId");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLicense = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/organizations/${organizationId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch license data");
        }

        const data = await response.json();
        // console.log("Fetched License Data:", data);
        if (data) {
          setLicense(data);
        }

      } catch (error) {
        console.error("Error fetching license data:", error);
        setError("Failed to fetch license data.");
      } finally {
        setLoading(false);
      }
    };

    if (!license) {
      fetchLicense();
    }
  }, [organizationId, license, token]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    document.body.classList.toggle("sidebar-enable");

    // For mobile and tablet views
    if (window.innerWidth <= 991) {
      document.body.classList.toggle("vertical-sidebar-enable");
    }
  };

  const toogleMenuBtn = () => {
    setIsActive(!isActive);

    var windowSize = document.documentElement.clientWidth;
    const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;

    if (windowSize > 767) humberIcon.classList.toggle("open");

    //For collapse horizontal menu
    if (document.documentElement.getAttribute("data-layout") === "horizontal") {
      document.body.classList.contains("menu")
        ? document.body.classList.remove("menu")
        : document.body.classList.add("menu");
    }

    //Two column menu
    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      document.body.classList.contains("twocolumn-panel")
        ? document.body.classList.remove("twocolumn-panel")
        : document.body.classList.add("twocolumn-panel");
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (divRef.current && !divRef.current.contains(event.target as Node)) {
      setIsActive(false); // Hide the div
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  // Close sidebar when clicking outside on MOBILE (≤767px)
  useEffect(() => {
    const handleDocClick = (e: MouseEvent) => {
      const isMobile = window.innerWidth <= 767;
      if (!isMobile) return;

      if (document.body.classList.contains("vertical-sidebar-enable")) {
        const target = e.target as Element;
        const insideSidebar = target.closest(".app-menu");
        if (!insideSidebar) {
          document.body.classList.remove("vertical-sidebar-enable");
          document.body.classList.remove("sidebar-enable");
        }
      }
    };

    document.addEventListener("mousedown", handleDocClick);
    return () => document.removeEventListener("mousedown", handleDocClick);
  }, []);

  // Keep your existing resize guard:
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 768) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.body.classList.remove("sidebar-enable");
      }
    };
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);



  function toTitleCase(input: string): string {
    return input
      .split(" ") // Split the string into words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter
      .join(" "); // Join the words back into a string
  }

  return (
    <header id="page-topbar">
      <div className="layout-width">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box horizontal-logo">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img
                    src={logo}
                    alt=""
                    height="17"
                  />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img
                    src={logo}
                    alt=""
                    height="17"
                  />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm p-0 fs-20 header-item d-inline-flex d-md-none" // 👈 only show ≤767px
              onClick={() => {
                document.body.classList.add("vertical-sidebar-enable");
              }}
              aria-label="Open sidebar"
            >
              <i className="ri-menu-2-line"></i>
            </button>
          </div>

          <div className="d-flex align-items-center">
            <div className="dropdown d-md-none topbar-head-dropdown header-item">
              <button
                type="button"
                className="btn btn-icon btn-topbar material-shadow-none btn-ghost-secondary rounded-circle"
                id="page-header-search-dropdown"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="bx bx-search fs-22"></i>
              </button>
              <div
                className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <button className="btn btn-primary" type="submit">
                        <i className="mdi mdi-magnify"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* <NotificationDropdown /> */}
            <ProfileDropdownn name={userName || "Guest"} role={userType || "Signage firm"} imageUrl={license?.profilePic || ""} login= {"signage"} token={token ||""} />
          </div>
        </div>
      </div>
    </header>
  );
};

export default SignageHeader;
